var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQtFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M153.987 28.235V87.55c.017 5.774 4.693 10.45 10.467 10.467h59.315V241.07a10.44 10.44 0 0 1-10.467 10.468H66.76a10.44 10.44 0 0 1-10.468-10.468V38.703A10.44 10.44 0 0 1 66.76 28.235zm16.617 0a10.47 10.47 0 0 1 7.414 3.053l42.698 42.742a10.43 10.43 0 0 1 3.053 7.37v2.661h-55.826V28.235z"
})));
export default SvgQtFile;